import { KeyValue } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkQueueStatus, WorkQueueType, WorkQueueUserOption, QueueActionsModel } from '@core/services/account-view/account-view.model';
import { AccountViewService } from '@core/services/account-view/account-view.service';
import { DescriptionModel } from '@core/services/base.model';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { UserService } from '@core/services/user/user.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from 'rxjs';
import { WorkQueueModel, QueueHistoryInfoModel, WorkQueueUpdateModel } from '../../core/services/work-queue/work-queue.model';
import { WorkQueueService } from '../../core/services/work-queue/work-queue.service';
import { ComponentCanDeactivate } from './account-view.guard';
import { MatInputModule } from '@angular/material/input'
import { QueueHistoryDialogComponent } from './queue-history-dialog/queue-history-dialog.component';
import { ComponentGridSettings, GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';

const PAGE_TITLE: string = 'Work Queue View'

@Component({
  selector: 'Teranet-AccountView',
  templateUrl: './account-view.component.html'
})
export class AccountViewComponent implements ComponentCanDeactivate, OnInit {
  workQueueModel = new WorkQueueModel();
  highlightSectionsDisabled: boolean = true;
  id: number;
  public workqueueStatusId: number =-1;
  public assignedStatusId: number=-1;
  nextId: number =-1;
  pageTitle: string = PAGE_TITLE;
  previousPage: string;
  queue: number;
  queueName: string;
  queueActionsFormArray: FormArray;
  public queueActions: QueueActionsModel[];
  queueActionsFormGroup: FormGroup;
  queueDisabled: boolean = true;
  queuePages: DescriptionModel[];
  selectedIndex: number = 0;
  public selectedQueueActionIndex: number = 0;
  usApplicable: boolean = false;
  //workqueueList: WorkQueueModel[];
  //workQueuePPSARegistrationOption = WorkQueuePPSARegistrationOption;
  workQueueStatus = WorkQueueStatus;
  workQueueType = WorkQueueType;
  workQueueUserOption = WorkQueueUserOption;
  workQueueUpdateModel: WorkQueueUpdateModel = new WorkQueueUpdateModel();
  public lookupPAN: string;
  public lookupPolicyNum: string;
  public lookupPostalCode: string;

  // Check for Pending Changes before Navigation
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    if (this.queueDisabled) {
      return true;
    }
    else {
      return false;
    }
  };

  @HostListener('document:click', ['$event'])
  onclick(event) {
    if (event.target.matches('.editor-div')) {
      alert('click to editor div')
    }
  }

  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose() {
    if (this.previousPage === 'workqueue') {
      this.goToWorkQueue();
    }
    else if (this.previousPage === 'lookup') {
      this.goBack();
    }

  }

  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private accountViewService: AccountViewService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private userService: UserService,
    private workQueueService: WorkQueueService
  ) {
    this.queueActionsFormArray = new FormArray([])

    this.queueActionsFormGroup = new FormGroup({
      accountUpdateGroup: new FormControl(-1),
      insuranceFollowupGroup: new FormControl(-1), 
      customerFollowupGroup: new FormControl(-1),
      comments: new FormControl(this.workQueueUpdateModel.comments),
      updateStatus: new FormControl(-1)
    });
  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params => {
      this.id = parseInt(params['id']);
      this.workqueueStatusId = parseInt(params['workqueueStatusId']);
      this.assignedStatusId = parseInt(params['assignedStatusId']);
      this.previousPage = params['previous_page'];
      //this.workQueueModel = params['obj'];
      this.queueName = params['queue'];
      if (params['queue'] == 'LenderRemediation') {
        this.queue = 1;
        //this.queueDisabled = true;
      }
      else if (params['queue'] == 'LenderReconciliation') {
        this.queue = 2;
        //this.queueDisabled = false;
      }
      else if (params['queue'] == 'Watchlist') {
        this.queue = 3;
        //this.queueDisabled = true;
      }
      else {
      }

      //this.queue = parseInt(params['queue']);

      if (this.previousPage === 'workqueue' || this.previousPage === 'lookup') {
        //this.spinner.show();
        this.getData();
      }
    });
  }


  checkSave() {

    if ((this.workQueueUpdateModel.workqueuestatusid != -1 &&
      this.workQueueUpdateModel.workqueueaccountupdateoptionid != -1 &&
      this.workQueueUpdateModel.workqueuecustomerfollowupoptionid != -1 &&
      this.workQueueUpdateModel.workqueueinsurancefollowupoptionid != -1) &&
      (
      this.workQueueUpdateModel.workqueuestatusid != this.workQueueModel.workqueuestatusid ||
      this.workQueueUpdateModel.workqueueaccountupdateoptionid != this.workQueueModel.workqueueaccountupdateoptionid ||
      this.workQueueUpdateModel.workqueueinsurancefollowupoptionid != this.workQueueModel.workqueueinsurancefollowupoptionid ||
      this.workQueueUpdateModel.workqueuecustomerfollowupoptionid != this.workQueueModel.workqueuecustomerfollowupoptionid ||
      this.workQueueUpdateModel.comments != this.workQueueModel.lastcomments
      )
    ) {
      this.queueDisabled = false;
    }
    else {
      this.queueDisabled = true;
    }

  }

  UpdateQueue() {
    if (this.id != undefined ) {
      let model = this.workQueueModel;
      this.workQueueUpdateModel.id = model.id;
      this.workQueueUpdateModel.workqueuestatusid = this.queueActionsFormGroup.get('updateStatus').value;
      this.workQueueUpdateModel.workqueueaccountupdateoptionid = this.queueActionsFormGroup.get('accountUpdateGroup').value;
      this.workQueueUpdateModel.workqueueinsurancefollowupoptionid = this.queueActionsFormGroup.get('insuranceFollowupGroup').value;
      this.workQueueUpdateModel.workqueuecustomerfollowupoptionid = this.queueActionsFormGroup.get('customerFollowupGroup').value;
      this.workQueueUpdateModel.workqueueinvestigationoptionid = -1;
      this.workQueueUpdateModel.comments = this.queueActionsFormGroup.get('comments').value;
      
      this.workQueueService.updateQueue(this.workQueueUpdateModel).subscribe(result => {
          if (result) {
            this.toastrService.success('Queue Updated Successfully', 'Success');
            this.queueDisabled = true;
            if (this.nextId != -1) {
              this.goToNextQueue();
            }
            else {
              this.goToWorkQueue();
            }
          }
          else {
            this.toastrService.success('Queue Updated Failed', 'Error');
          }
        });
      
    }
  }
  goToNextQueue() {
    if (this.nextId != -1) {
      this.router.navigate(['/accountview'], { queryParams: { from: 'accountview', queue: this.queueName, id: this.nextId, assignedStatusId: this.assignedStatusId, workqueueStatusId: this.workqueueStatusId, previous_page: this.previousPage } });
    }
    else {
      this.goToWorkQueue();
    }
  }

  ngAfterViewChecked() {
    document.querySelector('.mat-sidenav-container').scrollTop = 0;
  }

  getData(): void {

     this.accountViewService.getWorkQueueDetails(this.id).subscribe(r => {
       if (r != undefined) {
         this.workQueueModel = r;
         let model = this.workQueueModel;
         this.workQueueUpdateModel.id = model.id;
         this.workQueueUpdateModel.workqueuestatusid = model.workqueuestatusid;
         this.workQueueUpdateModel.workqueueaccountupdateoptionid = model.workqueueaccountupdateoptionid;
         this.workQueueUpdateModel.workqueueinsurancefollowupoptionid = model.workqueueinsurancefollowupoptionid;
         this.workQueueUpdateModel.workqueuecustomerfollowupoptionid = model.workqueuecustomerfollowupoptionid;
         this.workQueueUpdateModel.workqueueinvestigationoptionid = -1;
         this.workQueueUpdateModel.comments = model.lastcomments;
/*
         this.queueActionsFormGroup = new FormGroup({
           accountUpdateGroup: new FormControl(this.workQueueModel.workqueueaccountupdateoptionid == null ? -1 : this.workQueueModel.workqueueaccountupdateoptionid),
           insuranceFollowupGroup: new FormControl(this.workQueueModel.workqueueinsurancefollowupoptionid == null ? -1 : this.workQueueModel.workqueueinsurancefollowupoptionid),
           customerFollowupGroup: new FormControl(this.workQueueModel.workqueuecustomerfollowupoptionid == null ? -1 : this.workQueueModel.workqueuecustomerfollowupoptionid ),
           comments: new FormControl(this.workQueueUpdateModel.comments  ),
           updateStatus: new FormControl(this.workQueueModel.workqueuestatusid == null ? -1 : this.workQueueModel.workqueuestatusid)
         });
         */
        }
     });
    if (this.previousPage == 'workqueue') {
      switch (this.assignedStatusId) {
        case 1:
          this.accountViewService.getNextWorkQueue(this.queue, this.workqueueStatusId, this.id, 0, -1, -1, -1).subscribe(r => {
            if (r != undefined) { this.nextId = r; }
          });
          break;
        case 2:
          this.accountViewService.getNextWorkQueue(this.queue, this.workqueueStatusId, this.id, -1, 0, -1, -1).subscribe(r => {
            if (r != undefined) { this.nextId = r; }
          });
          break;
        case 3:
          this.accountViewService.getNextWorkQueue(this.queue, this.workqueueStatusId, this.id, -1, -1, -1, 0).subscribe(r => {
            if (r != undefined) { this.nextId = r; }
          });

          break;
        case 4:
          this.accountViewService.getNextWorkQueue(this.queue, this.workqueueStatusId, this.id, -1, -1, 0, -1).subscribe(r => {
            if (r != undefined) { this.nextId = r; }
          });

          break;
        default:
          this.accountViewService.getNextWorkQueue(this.queue, this.workqueueStatusId, this.id, -1, -1, -1, -1).subscribe(r => {
            if (r != undefined) { this.nextId = r; }
          });

          break;
      }
    }
    //const getQueuePages = this.workQueueService.getQueuePages();
    //const getAccountDetails = this.accountViewService.getAccountDetails(this.accountNumber, this.id, this.lvsOnly, this.fromAccount ? null : this.ppsaDate);
    //const getUserDashboardPreferences = this.userService.getUserDashboardPreferences(SiblingComponentName[this.previousPage]);
    //const getWorkQueue = this.workQueueService.getWorkQueue(this.queue);

    //if (this.previousPage === 'workqueue') {
    //  forkJoin([getQueuePages, getAccountDetails, getUserDashboardPreferences, getWorkQueue])
    //    .subscribe(responses => {
    //      this.queuePages = responses[0] as DescriptionModel[];
    //      this.accountViewModel = responses[1] as AccountViewModel;

    //      let componentPreferences = (responses[2] as any) as ComponentGridSettings[];
    //      let queueList = responses[3] as WorkQueueDetails;

    //      if (queueList && queueList.workQueueModels && componentPreferences && componentPreferences.length > 0) {
    //        this.workqueueList = this.processWorkQueue(queueList.workQueueModels, componentPreferences.find(c => c.componentName == SiblingComponentName[QueueName[this.queue]]));
    //      }

    //      this.setAccountDetails();
    //    });
    //}
    //else if (this.previousPage === 'lookup') {
    //  forkJoin([getQueuePages, getAccountDetails, getUserDashboardPreferences]).subscribe(responses => {
    //    this.queuePages = responses[0] as DescriptionModel[];
    //    this.accountViewModel = responses[1] as AccountViewModel;

    //    let componentPreferences = (responses[2] as any) as ComponentGridSettings[];
    //    let preference: ComponentGridSettings = componentPreferences.find(c => c.componentName == SiblingComponentName[this.previousPage]);

    //    this.lookupVINNum = preference?.customizedSettings?.vinNumber;
    //    this.lookupAccountNum = preference?.customizedSettings?.accountNumber;

    //    this.setAccountDetails();
    //  });
    //}

    if (this.previousPage === 'lookup')
    {
      this.userService.getUserDashboardPreferences("LookupPageComponent").subscribe(r => {
        if (r != undefined) {
          let componentPreferences = (r as any) as ComponentGridSettings[];
          let preference: ComponentGridSettings = componentPreferences.find(c => c.componentName == "LookupPageComponent");

          this.lookupPAN = preference?.customizedSettings?.productAccountNumber;
          this.lookupPolicyNum = preference?.customizedSettings?.policyNumber; 
          this.lookupPostalCode = preference?.customizedSettings?.postalCode;
        }
      });      
    }
  }

  getNextAccountDetails(): void {
    //if (this.workqueueList) {
    //  let currentIndex = this.workqueueList.findIndex(obj => obj.lmsVinId === this.id && obj.accountNumber === this.accountNumber);

    //  if (currentIndex != this.workqueueList.length - 1) {
    //    const nextItem = this.workqueueList[currentIndex + 1];

    //    this.spinner.show();
    //    this.accountNumber = nextItem.accountNumber;
    //    this.id = nextItem.lmsVinId;
    //    this.lvsOnly = nextItem.lvsOnly;
    //    this.ppsaDate = nextItem.ppsaDate;
    //    this.resetToDefault();
    //    this.getAccountDetails(this.accountNumber, this.id, this.lvsOnly, this.ppsaDate);
    //  }
    //  else {
    //    this.toastrService.info('This is the last Account View.');
    //  }
    //}
  }

  goBack(): void {
      this.router.navigate([this.previousPage], {
        queryParams: {
          from: 'accountview',
          PAN: this.lookupPAN,
          policyNumber: this.lookupPolicyNum,
          postalCode: this.lookupPostalCode
        }
      });
  }

  goToNextAccountView(): void {
    if (this.canDeactivate()) {
      this.getNextAccountDetails();
    }
    else {
      if (confirm('WARNING: You have unsaved changes under Queue Actions.\r\nChoose ‘OK’ to discard changes and proceed or ‘Cancel’ to stay on page.')) {
        this.getNextAccountDetails();
      }
    }
  }

  goToWorkQueue(): void {
    this.router.navigate(['/workqueue'], { queryParams: { from: 'accountview', queuetype: this.queue } });
  }


  onQueueActionTabChange(event: any): void {
    this.selectedQueueActionIndex = event.index;
    this.setQueueActionDisabled(event.index);
  }
  setQueueActionDisabled(index: number): void {
    this.setCompletedQueueActionDisabled(index);
    this.setUnderReviewQueueActionDisabled(index);
    //this.setCQDefaultQueueAction();
  }


  setQueueActions(reset: boolean): void {
        
      // FIRST VISIT
    if (!reset) {
      this.queueActionsFormGroup.controls['comments'].setValue(this.workQueueModel.lastcomments);
      }
    else if (reset) {  // RESET
      let model = this.workQueueModel;
      this.workQueueUpdateModel.id = model.id;
      this.workQueueUpdateModel.workqueuestatusid = model.workqueuestatusid;
      this.workQueueUpdateModel.workqueueaccountupdateoptionid = model.workqueueaccountupdateoptionid;
      this.workQueueUpdateModel.workqueueinsurancefollowupoptionid = model.workqueueinsurancefollowupoptionid;
      this.workQueueUpdateModel.workqueuecustomerfollowupoptionid = model.workqueuecustomerfollowupoptionid;
      this.workQueueUpdateModel.workqueueinvestigationoptionid = -1;
      this.workQueueUpdateModel.comments = model.lastcomments;
      this.queueDisabled = true;
         
      }
    
  }


  setCompletedQueueActionDisabled(index: number): void {
    let disableCompleteQueueAction: boolean = this.queueActionsFormArray.controls[index].get('underReview').value
      || this.queueActionsFormArray.controls[index].get('account').value === this.workQueueUserOption.Assign
      || this.queueActionsFormArray.controls[index].get('insurance').value === this.workQueueUserOption.Assign
      || this.queueActionsFormArray.controls[index].get('customer').value === this.workQueueUserOption.Assign
      || this.queueActionsFormArray.controls[index].get('investigation').value === this.workQueueUserOption.Assign
    let completeQueueAction = this.queueActionsFormArray.controls[index].get('completed');
    if (disableCompleteQueueAction) {
      let changedWorkQueueStatus = this.queueActionsFormArray.controls[index].get('workQueueStatus');
      if (changedWorkQueueStatus.value === this.workQueueStatus.Complete && changedWorkQueueStatus.value != this.queueActionsFormArray.controls[index].get('currentWorkQueueStatus').value) {
        changedWorkQueueStatus.setValue(this.queueActionsFormArray.controls[index].get('currentWorkQueueStatus').value)
        completeQueueAction.setValue(false);
      }
      completeQueueAction.disable();
    } else {
      completeQueueAction.enable();
    }
  }


  setUnderReviewQueueActionDisabled(index: number): void {
    let disableUnderReview: boolean = this.queueActionsFormArray.controls[index].get('completed').value || this.queueActionsFormArray.controls[index].get('currentWorkQueueStatus').value === this.workQueueStatus.UnderReview;
    if (disableUnderReview) {
      this.queueActionsFormArray.controls[index].get('underReview').disable();
    } else {
      this.queueActionsFormArray.controls[index].get('underReview').enable();
    }
  }



  onSubmit() {
    //if (this.queueActionsFormGroup.errors?.notCompleted) {
    //  this.toastrService.error('Please fill in all required fields.', 'Error');
    //  return;
    //}

    //if (this.queueActionsFormArray.controls.findIndex(c => c.dirty) < 0) {
    //  this.toastrService.error('Please make an update to Queue Actions before saving.', 'Error');
    //  return;
    //}

    //this.spinner.show();

    //const queueActions = [];

    //this.queueActionsFormArray.controls.forEach(queue => {
    //  if (queue.dirty) {
    //    queueActions.push(queue.value)
    //  }
    //});

    //this.accountViewService.postQueueActions(queueActions).subscribe(result => {
    //  if (result) {
    //    //this.getAccountDetails(this.accountNumber, this.id, this.lvsOnly, this.ppsaDate);
    //  }
    //  else {
    //    this.spinner.hide();
    //  }
    //});
  }


  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  permissionCheck(workQueueType: WorkQueueType, workQueueTtitle: string): boolean {
    if (this.queuePages !== null && this.queuePages.length > 0) {

      if (this.queuePages.some(q => q.description === workQueueTtitle)) {
        return true;
      }
    }
    return false;
  }
  
  
  getWorkQueueType(queueType: number): WorkQueueType {
    switch (queueType) {
      case 1:
        return WorkQueueType.LenderRemediation
      case 2:
        return WorkQueueType.LenderReconciliation;
      case 3:
        return WorkQueueType.WatchList;
    }
  }

  getWorkQueueStatus(): string {
    switch (this.workQueueModel.workqueuestatusid) {
      case 1:
        return "New";
      case 2:
        return "Under Review";
      case 3:
        return "Completed";
      default:
        return ""
    }
  }

  openQueueHistoryDialog(): void {
    this.dialog.open(QueueHistoryDialogComponent, {
      data: this.workQueueModel.queueHistoryDetails
    });
  }

  Cancel() { }
  Save() {
    
        
    /*
    
    this.workQueueUpdateModel.statusid = model.statusid;
    this.workQueueUpdateModel.firstname = this.editFormGroup.get("firstName").value;
    if (this.workQueueUpdateModel.firstname == '') this.workQueueUpdateModel.firstname = model.borrowersfirstname;
    this.workQueueUpdateModel.lastname = this.editFormGroup.get("lastName").value;
    if (this.workQueueUpdateModel.lastname == '') this.workQueueUpdateModel.lastname = model.borrowerslastname;
    this.workQueueUpdateModel.postalcode = this.editFormGroup.get("postalCode").value;
    if (this.workQueueUpdateModel.postalcode == '') this.workQueueUpdateModel.postalcode = model.lenderpostalcode;
    this.workQueueService.updateQueue(this.workQueueUpdateModel).subscribe(result => {
      if (result) {
        this.toastrService.success('Queue Updated Successfully', 'Success');
        if (this.nextId != -1) {
          this.goToNextQueue();
        }
        else {
          this.goToWorkQueue();
        }
      }
      else {
        this.toastrService.success('Queue Updated Failed', 'Error');
      }
    });
    */
  }

  setTitle() {
    if (this.workQueueModel.lendercorporationcode) {
      this.pageTitle = PAGE_TITLE + " (" + this.workQueueModel.lendercorporationcode.toUpperCase() + ")";
    }
    else {
      this.pageTitle = PAGE_TITLE;
    }
  }

  setWorkQueueStatus(checked: boolean, workQueueStatus: WorkQueueStatus, index: number) {
    if (checked) {
      this.queueActionsFormArray.controls[index].get('workQueueStatus').setValue(workQueueStatus);
    }
    else {
      this.queueActionsFormArray.controls[index].get('workQueueStatus')
        .setValue(this.queueActionsFormArray.controls[index].get('currentWorkQueueStatus').value);
    }
  }
}

  export const completeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control) {
      const account = control.get('account').value;
      const customer = control.get('customer').value;
      const insurance = control.get('insurance').value;
      const investigation = control.get('investigation').value;
      const workQueueStatus = control.get('workQueueStatus').value;
      const workQueueType = control.get('workQueueType').value;
           
    }
    else {
      return null;
    }
  };

